<template>
  <div>
    <div style="position: relative; width: 1024px; display: inline-block;">

      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1024" height="351" viewBox="0 0 1024 351">
        <defs>
          <path id="prefix__a" d="M0.217 0.337L63.775 0.337 63.775 63.896 0.217 63.896z"/>
          <path id="prefix__c" d="M0 0.168L76.219 0.168 76.219 76.386 0 76.386z"/>
          <path id="prefix__e" d="M0.182 0.512L66.841 0.512 66.841 67.17 0.182 67.17z"/>
          <path id="prefix__g" d="M0.528 0.077L49.493 0.077 49.493 49.042 0.528 49.042z"/>
          <path id="prefix__i" d="M0 0.318L73.646 0.318 73.646 73.965 0 73.965z"/>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <g>
            <path fill="#F0E8DD" d="M546.798 0L494.102 20.704 494.102 82.817 599.494 82.817 599.494 20.704z" transform="translate(-237) translate(0 267)"/>
            <path fill="#ABD193" d="M1024.831 76.22L802.219 54.584 659.52 69.455 504.021 55.212 0 84 1724.441 84 1303.76 27.606z" transform="translate(-237) translate(0 267)"/>
          </g>

          <slot name="g"/>

        </g>
      </svg>

      <slot/>
    </div>
  </div>
</template>

<script>

export default {
}
</script>

<style scoped>

</style>
